import { render, staticRenderFns } from "./ActivityNameSetting.vue?vue&type=template&id=572dde23"
import script from "./ActivityNameSetting.vue?vue&type=script&lang=js"
export * from "./ActivityNameSetting.vue?vue&type=script&lang=js"
import style0 from "./ActivityNameSetting.vue?vue&type=style&index=0&id=572dde23&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports